import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { getToastErrorMessage, LogyxError } from 'services/api/errors';
import { ReactMutationKeys } from 'services/api/reactMutationKeys';
import { companyLogin } from 'services/UserService';

interface IUseCompanyLogin {
  email: string;
  password: string;
  token: string;
}
export const useCompanyLogin = () => {
  const { t } = useTranslation();
  return useMutation((params: IUseCompanyLogin) => companyLogin(params), {
    onError: (error: LogyxError) => {
      toast.error(getToastErrorMessage(error));
    },
    mutationKey: ReactMutationKeys.COMPANY_LOGIN,
  });
};
